import React from 'react'
import { Link } from 'react-router-dom'

export default function Navbar() {

  return (

    <>

      <nav className="navbar navbar-expand-lg navbar-light bg-light">

        <div className="container-fluid">

          {/* LOGO */}

          <Link to="/" className="navbar-brand" href="#">
  <img
    className='img-fluid'
    id="logo"
    src="btslogo.png"
    alt=""
    
  />
</Link>

{/* MOBILE BUTTONS */}
<div className="d-flex d-lg-none align-items-center ms-auto">

  <div className="dropdown me-2">
    <button
      className="btn btn-primary btn-sm"
      type="button"
      data-bs-toggle="dropdown"
    >
      🎓 Online Degree ▼
    </button>

    <ul className="dropdown-menu dropdown-menu-end">
      <li><Link className="dropdown-item" to="/course/BA">BA</Link></li>
      <li><Link className="dropdown-item" to="/course/BCom">BCom</Link></li>
      <li><Link className="dropdown-item" to="/course/BBA">BBA</Link></li>
      <li><Link className="dropdown-item" to="/course/BCA">BCA</Link></li>
      <li><Link className="dropdown-item" to="/course/MA">MA</Link></li>
      <li><Link className="dropdown-item" to="/course/MSc">MSc</Link></li>
      <li><Link className="dropdown-item" to="/course/MCom">MCom</Link></li>
      <li><Link className="dropdown-item" to="/course/MBA">MBA</Link></li>
      <li><Link className="dropdown-item" to="/course/MCA">MCA</Link></li>
      <li><Link className="dropdown-item" to="/course/MAJMC">MAJMC</Link></li>
    </ul>
  </div>

  <a
    href="tel:+919540155567"
    className="btn btn-success btn-sm me-2"
  >
    📞 9540155567 

  </a>

</div>
<br></br>
{/* TOGGLER */}
<button
  className="navbar-toggler"
  type="button"
  data-bs-toggle="collapse"
  data-bs-target="#navbarSupportedContent"
>
  <span className="navbar-toggler-icon"></span>
</button>

          {/* NAVBAR */}

          <div
            className="collapse navbar-collapse"
            id="navbarSupportedContent"
          >

            <ul className="navbar-nav me-auto mb-2 mb-lg-0">

              <li className="nav-item">

                <Link
                  className="nav-link"
                  to="/"
                  id="lc"
                >
                  Home
                </Link>

              </li>

              <li className="nav-item">

                <Link
                  className="nav-link"
                  to="/muj"
                  id="lc"
                >
                  Manipal University Jaipur
                </Link>

              </li>

              <li className="nav-item">

                <Link
                  className="nav-link"
                  to="/smu"
                  id="lc"
                >
                  Sikkim Manipal University
                </Link>

              </li>

              <li className="nav-item">

                <Link
                  className="nav-link"
                  to="/contact#contact-form"
                  id="lc"
                >
                  Contact
                </Link>

              </li>

            </ul>



        {/* DROPDOWN */}

<div className="dropdown degree-dropdown d-none d-lg-flex">

  <button
    className="btn dropdown-btn dropdown-toggle"
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >

    🎓 Online Degrees

  </button>

  <ul className="dropdown-menu custom-dropdown dropdown-menu-end">

    <li>
      <Link
        className="dropdown-item custom-item"
        to="/course/BA"
      >
        🎨 BA Online
      </Link>
    </li>

    <li>
      <Link
        className="dropdown-item custom-item"
        to="/course/BCom"
      >
        📚 BCom Online
      </Link>
    </li>

    <li>
      <Link
        className="dropdown-item custom-item"
        to="/course/BBA"
      >
        📊 BBA Online
      </Link>
    </li>

    <li>
      <Link
        className="dropdown-item custom-item"
        to="/course/BCA"
      >
        💻 BCA Online
      </Link>
    </li>

    <li>
      <Link
        className="dropdown-item custom-item"
        to="/course/MA"
      >
        📝 MA Online
      </Link>
    </li>

    <li>
      <Link
        className="dropdown-item custom-item"
        to="/course/MSc"
      >
        🔬 MSc Online
      </Link>
    </li>

    <li>
      <Link
        className="dropdown-item custom-item"
        to="/course/MCom"
      >
        💰 MCom Online
      </Link>
    </li>

    <li>
      <Link
        className="dropdown-item custom-item"
        to="/course/MBA"
      >
        📈 MBA Online
      </Link>
    </li>

    <li>
      <Link
        className="dropdown-item custom-item"
        to="/course/MCA"
      >
        🖥 MCA Online
      </Link>
    </li>

    <li>
      <Link
        className="dropdown-item custom-item"
        to="/course/MAJMC"
      >
        🎥 MAJMC
      </Link>
    </li>

  </ul>


  {/* Call Button */}
  <a
    href="tel:+919876543210"
    className="btn btn-success ms-2"
  >
    📞 9540155567
  </a>

</div>



          </div>

        </div>

      </nav>

    </>

  )
}